import { setPath } from "myredux/globalSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { StoreState } from "types";
import { isUndefined } from "utils/commonUtils";
import { logout } from "myredux/loginSlice";

export const useDefault = () => {
    const { employee, isOwner, isBasicEmployee } = useSelector((state: StoreState) => state.login);
    const { path, appSetting, branches, selectedBranchId, strictCashdesk } = useSelector((state: StoreState) => state.global);
    
    const navigation = useNavigate();
    const dispatch = useDispatch();
    
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!isUndefined(path)) {
            navigation(path!);
            dispatch(setPath(""));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path]);

    return {
        employee,
        branches,
        selectedBranchId,
        strictCashdesk,
        selectedBranch: branches.filter(b => b.id === selectedBranchId)[0],
        isOwner,
        isBasicEmployee,
        navigation,
        dispatch,
        loading,
        setLoading,
        path,
        appSetting,
        handleLogout: () => dispatch(logout()),
        isMobile: window.innerWidth < 768
    };
};